import { useRef } from "react";
import { ValidationGroup } from "devextreme-react/validation-group";
import InputField from "components/common/controls/InputField";
import FormGroup from "components/common/FormGroup";
import ContactSalesRequest from "interfaces/request/ContactSalesRequest";
import EditorActionFooter from "components/common/EditorActionFooter";
import { useDispatch } from "react-redux";
import { AppDispatch } from "store/store";
import PromTextarea from "components/common/controls/PromTextarea";
import { contactToSales } from "store/slices/ContactSalesSlice";
import { getTermsAndUsePdfUrl } from "shared/utility/ConfigUtility";

interface Props {
  userName?: string;
  userEmail?: string;
  userPhone?: string;
  userCompany?: string;
  productId: number;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export default function ContactSalesForm(props: Props) {
  const formValidationGroupRef = useRef<any>(null);
  const formRef = useRef<any>(null);
  const dispatch: AppDispatch = useDispatch();

  const {
    userName,
    userEmail,
    userPhone,
    userCompany,
    productId,
    onSuccess,
    onCancel,
  } = props;

  const handleSubmit = () => {
    var validationResult = formValidationGroupRef.current.instance.validate();

    if (!validationResult.isValid) {
      return;
    }

    const { name, email, phone, companyName, notes } = formRef.current;

    const contactSalesRequest: ContactSalesRequest = {
      name: name.value,
      email: email.value,
      phone: phone.value,
      companyName: companyName.value,
      notes: notes.value,
      productId: productId,
    };

    dispatch(contactToSales(contactSalesRequest)).then(() => {
      onSuccess?.();
    });
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <>
      <div>
        <form ref={formRef}>
          <ValidationGroup ref={formValidationGroupRef}>
            <div className="grid gap-y-6">
              <FormGroup label="Name">
                <InputField
                  placeholder="Name"
                  name="name"
                  defaultValue={userName}
                  maxLength={50}
                  required
                  id="name"
                  label="name"
                />
              </FormGroup>
              <FormGroup label="Email">
                <InputField
                  id="email"
                  mode="email"
                  label="Email"
                  maxLength={255}
                  placeholder="e.g. john.doe@provider.com"
                  name="email"
                  required={true}
                  defaultValue={userEmail}
                />
              </FormGroup>
              <FormGroup label="Phone (inc. country code)">
                <InputField
                  key="phone"
                  placeholder="e.g. +47 123 45 678"
                  // mask="+(00) (000) (00) (000)"
                  maxLength={50}
                  name="phone"
                  id="phone"
                  label="Phone"
                  defaultValue={userPhone}
                  required
                />
              </FormGroup>
              <FormGroup label="Company Name">
                <InputField
                  placeholder="Company Name"
                  name="companyName"
                  id="companyName"
                  label="companyName"
                  defaultValue={userCompany}
                />
              </FormGroup>
              <FormGroup label="Notes to sales team  ">
                <PromTextarea
                  placeholder="Notes to sales team  "
                  name="notes"
                  height="80"
                  id="notes"
                  label="Notes"
                />
              </FormGroup>
            </div>
          </ValidationGroup>
        </form>
        <div className="mt-5">
          <span>
            By clicking submit you are agreeing to the{" "}
            <a href={getTermsAndUsePdfUrl()} target="_blank"  rel="noreferrer" className="underline"> 
             terms and conditions.
            </a> 
          </span>{" "}
        </div>
        <div className="mt-7 float-right">
          <EditorActionFooter
            onApply={handleSubmit}
            onCancel={handleCancel}
            applyButtonCaption="SUBMIT"
          />
        </div>
      </div>
    </>
  );
}
